import { combineReducers } from "redux";
import toc from "./features/toc/reducer";
import highlights from "./features/highlights/reducer";
import markers from "./features/markers/reducer";
import bookInfo from "./features/bookinfo/reducer";
import contentControls from "./features/content-controls/reducer";
import sharing from "./features/sharing/reducer";
import citations from "./features/citations/reducer";
import viewer from "./features/viewer/reducer";
import user from "./features/user/reducer";
import pagebreaks from "./features/pagebreaks/reducer";
import print from "./features/print/reducer";
import tts from "./features/tts/reducer";
import nav from "./features/nav/reducer";
import bookmarks from "./features/bookmarks/reducer";
import figures from "./features/figures/reducer";
import overleaf from "./features/overleaf/reducer";
import locations from "./features/locations/reducer";
import search from "./features/search/reducer";
import ariaLive from "./features/aria-live/reducer";
import enrichments from "./features/enrichments/reducer";
import sessionKv from "./features/session-kv";
import ancillaries from "./features/ancillaries/reducer";
import textSelect from "./features/text-select/reducer";
import preferences from "./features/preferences/reducer";
import lastPage from "./features/last-page/reducer";
import spine from "./features/spine/reducer";
import ai from "./features/ai/reducer";

export default combineReducers({
  toc,
  highlights,
  markers,
  bookInfo,
  contentControls,
  sharing,
  citations,
  viewer,
  user,
  pagebreaks,
  print,
  tts,
  nav,
  bookmarks,
  figures,
  overleaf,
  locations,
  search,
  ariaLive,
  enrichments,
  sessionKv,
  ancillaries,
  textSelect,
  preferences,
  lastPage,
  spine,
  ai,
});
